<!--
 * @Description: 导出明细弹窗组件
 * @Author: brian
 * @Date: 2024-01-12 14:51:13
 * @LastEditTime: 2024-01-12 14:51:13
 * @LastEditors: brian
-->
<template>
  <cos-modal
    v-model:visible="visible"
    title="导出明细"
    width="500px"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :model="dataForm" ref="formRef" :rules="formRules" :wrapper-col="{ span: 24 }">
      <dc-form-item name="taskId" label="文件类型" :span="24">
        <CosSelect v-model:value="dataForm.taskId" :options="props.taskTypeEnum" allowClear />
      </dc-form-item>
    </a-form>
  </cos-modal>
</template>

<script setup lang="ts">
import { ref, watch, onBeforeMount } from 'vue'
import { cloneDeep } from 'lodash-es'
import { message as DcMessage } from '@dc-platform/dc-components'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import { exportList } from '@/api/common'
import { useI18n } from 'vue-i18n'
import { selectForNumberValidate } from '@/utils/validate'

const { t } = useI18n()

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const initForm = { taskId: -9 }
const dataForm = ref(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  taskId: [{ required: true, validator: selectForNumberValidate, message: '请选择文件类型' }]
}

const props = defineProps({
  search: {
    type: Object,
    default: () => {
      return {}
    }
  },
  taskTypeEnum: {
    type: Object
  },
  appId: {
    type: String
  }
})

watch(
  () => visible.value,
  (val) => {
    if (!val) {
      formRef.value?.resetFields()
      dataForm.value = cloneDeep(initForm)
    }
  }
)

const handleOk = () => {
  formRef.value?.validate().then(() => {
    const { pageNumber, pageSize, ...other } = props.search

    exportList({
      appId: props.appId,
      taskType: dataForm.value.taskId,
      query: other
    })
      .then((res) => {
        DcMessage.success(t('tips.exportSuccess'))
      })
      .finally(() => {
        loading.value = false
        visible.value = false
      })
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
}

const init = () => {
  visible.value = true
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'ExportDetails' }
</script>

  <style lang="scss" scoped></style>
